import React from 'react'
import { Form } from 'react-bootstrap'
import { CountryDropdown } from 'react-country-region-selector'
import { FormikErrors, FormikTouched } from 'formik'

interface SingaporeAddressFieldsProps {
  values: {
    address1: string
    address2: string
    city: string
    region: string
    country: string
    zipCode: string
  }
  errors: FormikErrors<{
    address1: string
    address2: string
    city: string
    region: string
    country: string
    zipCode: string
  }>
  handleChange: {
    (e: React.ChangeEvent<any>): void
    <T = string | React.ChangeEvent<any>>(
      field: T
    ): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void
  }
  handleBlur: {
    (e: React.FocusEvent<any>): void
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void
  }
  touched: FormikTouched<{
    address1: string
    address2: string
    city: string
    region: string
    country: string
    zipCode: string
  }>
}

const SingaporeAddressFields: React.FC<SingaporeAddressFieldsProps> = ({
  values,
  errors,
  handleChange,
  handleBlur,
  touched
}) => {
  return (
    <div data-testid="singaporeAddressFieldFC">
      <Form.Group>
        <Form.Label htmlFor="recipient-country">Country</Form.Label>
        <Form.Control
          id="recipient-country"
          as={CountryDropdown}
          name="country"
          value={values.country}
          data-testid="countryOption"
          disabled
        />
      </Form.Group>

      <Form.Group>
        <Form.Label htmlFor="recipient-zipCode">Postal code</Form.Label>
        <Form.Control
          id="recipient-zipCode"
          type="text"
          name="zipCode"
          placeholder="type postal code"
          value={values.zipCode}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.zipCode && !!errors.zipCode}
        />
        <Form.Control.Feedback type="invalid">
          {errors.zipCode}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group>
        <Form.Label htmlFor="recipient-address1">Detailed Address</Form.Label>
        <Form.Control
          id="recipient-address1"
          type="text"
          name="address1"
          placeholder="unit #, building, street"
          value={values.address1}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.address1 && !!errors.address1}
        />
        <Form.Control.Feedback type="invalid">
          {errors.address1}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  )
}

export default SingaporeAddressFields
